import { DashboardView } from './DashboardView';
import { connect } from 'react-redux';
import { dashboardViewIsPendingSel } from 'src/store/modules/dashboardview';
import { userActions } from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    isPending: dashboardViewIsPendingSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getUserDetails: () => dispatch(userActions.getUserDetails())
});

export const pureComponent = DashboardView;
export default connect(mapStateToProps, mapDispatchToProps)(DashboardView);

interface IDispatchFromProps {
  getUserDetails(): void;
}
